import { render, staticRenderFns } from "./GenerateTestForms.vue?vue&type=template&id=ace737ae&scoped=true&"
import script from "./GenerateTestForms.vue?vue&type=script&lang=js&"
export * from "./GenerateTestForms.vue?vue&type=script&lang=js&"
import style0 from "./GenerateTestForms.vue?vue&type=style&index=0&id=ace737ae&lang=scss&scoped=true&"
import style1 from "./GenerateTestForms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace737ae",
  null
  
)

export default component.exports